import React, { useState } from 'react';
import { Button, Menu, MenuItem, Box, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../i18n';

export default function LanguageSelector({ compact = false }) {
  const { i18n } = useTranslation();
  const [anchor, setAnchor] = useState(null);

  const langCode = i18n.language?.split('-')[0] || 'en';
  const current = LANGUAGES.find((l) => l.code === langCode) || LANGUAGES[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    setAnchor(null);
  };

  return (
    <>
      <Button
        onClick={(e) => setAnchor(e.currentTarget)}
        startIcon={<LanguageIcon sx={{ fontSize: '1rem !important' }} />}
        endIcon={!compact && <KeyboardArrowDownIcon sx={{ fontSize: '1rem !important' }} />}
        sx={{
          color: 'text.secondary',
          fontWeight: 500,
          fontSize: '0.85rem',
          px: 1.5,
          minWidth: 'auto',
          '&:hover': { background: 'rgba(99,102,241,0.06)', color: 'primary.main' },
        }}
      >
        {compact ? current.flag : `${current.flag} ${current.label}`}
      </Button>

      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 20px 40px -8px rgba(0,0,0,0.12)',
            border: '1px solid rgba(99,102,241,0.1)',
            minWidth: 160,
            mt: 1,
          },
        }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => change(lang.code)}
            selected={lang.code === langCode}
            sx={{
              borderRadius: 2, mx: 1, my: 0.3,
              '&.Mui-selected': { background: 'rgba(99,102,241,0.1)', fontWeight: 600 },
            }}
          >
            <Box sx={{ mr: 1.5, fontSize: '1.2rem' }}>{lang.flag}</Box>
            <Typography variant="body2" fontWeight={lang.code === i18n.language ? 600 : 400}>
              {lang.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
